(function () {

    'use strict';

    EmailTemplateService.$inject = [
        'fileShareApi'
    ];

    function EmailTemplateService(fileShareApi) {
        var service = {
            getAllTemplates: getAllTemplates,
            getTemplate: getTemplate,
            resetTemplate: resetTemplate,
            updateTemplate: updateTemplate
        };

        return service;

        function getAllTemplates() {
            return fileShareApi.getAllEmailTemplates();
        }

        function getTemplate(slug) {
            return fileShareApi.getEmailTemplate(slug);
        }

        function resetTemplate(slug) {
            return fileShareApi.resetEmailTemplate(slug);
        }

        function updateTemplate(template) {
            return fileShareApi.updateEmailTemplate(template);
        }
    }

    module.exports = EmailTemplateService;
})();